export default `
mutation USER_MUTATION($phone: String!) {
  resetPin(phone: $phone) {
    message
    code
  }
}
`
